<div *ngIf="isAllowed">
  <mat-card class="header" [ngClass]="dealerImageDetails?.url ? 'header-with-image':'header-without-image'">
  <div class="header-image">
    @if (dealerImageDetails?.url) {
      <img [src]=[dealerImageDetails?.url] alt="File not found." i18n-alt />
    }
  </div>
  <div class="header-text">
    <div class="basic-info">
      @if (reportResponse?.name) {
        <div class="request-text">{{reportResponse.name}}</div>
      }
      <div class="date-time">{{formatedDateTime}}</div>
    </div>
    @if (reportResponse?.order?.customer) {
      <div class="user-info">
        <div class="user-name">{{reportResponse.order?.customer?.name}}</div>
        <div class="vehicle-model"> {{reportResponse.order?.vehicle?.model}} {{reportResponse.order?.vehicle?.make}}
        </div>
        <div class="vehicle-no"> {{reportResponse.order?.vehicle?.licenseNo}} </div>
      </div>
    }
  </div>
  @if (reportResponse) {
    <div class="pdf-container">
      <button  [disabled]="!isPDFDataAvailable" matTooltip="Download PDF" i18n-matTooltip (click)="downloadPDF()"
        class="button-pdf" mat-mini-fab color="primary">
        <img #downloadPDFTour class="download-icon" class="button-pdf" src="../../assets/common/download.svg"
          alt="File not found." i18n-alt />
        </button>
      </div>
    }
  </mat-card>

  @if (reportResponse) {
    <div>
      @if (getWalkthroughFilteredCategories(reportResponse).length > 0) {
        <div>
          <app-vehicle-walkthrough [categories]="getWalkthroughFilteredCategories(reportResponse)"></app-vehicle-walkthrough>
        </div>
      }
    </div>
  }

  <div class="container-category">
    @if (reportResponse?.urgentRequired) {
      <mat-card class="fair-findings urgent-required" >
        <div class="findings-content">
          <div class="findings-discription" i18n>Critical</div>
          <div class="findings-count">
            {{urgentRequiredCount}}
            @if (reportResponse.urgentRequired?.count == 1) {
              <span i18n>finding</span>
            } @else {
              <ng-container i18n>findings</ng-container>
            }
          </div>
        </div>
        <div class="findings-icon">
          <div class="forward-arrow-icon icon-red" [routerLink]="['/', 'vhc-report', 'report']" [queryParams]="{categoryType: 'urgentRequired', token: token}">
            <div #criticalTour >
              <mat-icon>arrow_forward_ios</mat-icon>
            </div>
          </div>
        </div>
      </mat-card>
    }
    @if (reportResponse?.attentionRequired) {
      <mat-card class="fair-findings attention-required">
        <div class="findings-content">
          <div class="findings-discription" i18n>Attention required</div>
          <div class="findings-count" >
            {{ attentionRequiredCount }}
            @if (reportResponse.attentionRequired?.count == 1) {
              <span i18n>finding</span>
            } @else {
              <ng-container i18n>findings</ng-container>
            }
          </div>
        </div>
        <div class="findings-icon">
          <div class="forward-arrow-icon icon-yellow" [routerLink]="['/', 'vhc-report', 'report']" [queryParams]="{categoryType: 'attentionRequired', token: token}">
            <div #attenctionRequiredTour>
              <mat-icon>arrow_forward_ios</mat-icon>
            </div>
          </div>
        </div>
      </mat-card>
    }
    @if (reportResponse?.categoriesOk) {
      <mat-card class="fair-findings checked-and-ok">
        <div class="findings-content">
          <div class="findings-discription" i18n>Checked and Ok</div>
          <div class="findings-count">
            {{categoriesOkCount}}
            @if (reportResponse.categoriesOk?.count == 1) {
              <span i18n>finding</span>
            } @else {
              <ng-container i18n>findings</ng-container>
            }
          </div>
        </div>
        <div class="findings-icon">
          <div class="forward-arrow-icon icon-green" [routerLink]="['/', 'vhc-report', 'report']" [queryParams]="{categoryType: 'categoriesOk', token: token}">
            <div #checkedAndOkTour>
              <mat-icon>arrow_forward_ios</mat-icon>
            </div>
          </div>
        </div>
      </mat-card>
    }
  </div>

</div>

<div *ngIf="!isAllowed"></div>